import { createApp } from 'vue'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { i18n } from './i18n' 

// Components
import App from './App.vue'
import VueKinesis from "vue-kinesis";

const vuetify = createVuetify({
  components,
  directives,
})

async function setLanguageBasedOnLocation() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    if (data && data.country_code === 'PL') {
      i18n.global.locale = 'pl';
    } else {
      i18n.global.locale = 'en';
    }
  } catch (error) {
    console.error("Nie udało się pobrać geolokalizacji użytkownika:", error);
  }
}

(async () => {
  await setLanguageBasedOnLocation();

  const app = createApp(App);
  app.use(VueKinesis);
  app.use(vuetify);
  app.use(i18n);
  app.mount('#app');
})();
